import React from "react";
import { Badge } from "react-bootstrap";
import { RGCStatus } from "src/store/SpitKit/Types";

type RGCStatusDisplay = { text: string; gradient: string };

const statusDisplays: Record<RGCStatus, RGCStatusDisplay> = {
  ordered: {
    text: "Ordered",
    gradient: "linear-gradient(135deg, #64748b, #475569)",
  },
  pending: {
    text: "Pending",
    gradient: "linear-gradient(135deg, #d97706, #b45309)",
  },
  in_fulfillment: {
    text: "In Fulfillment",
    gradient: "linear-gradient(135deg, #6366f1, #4338ca)",
  },
  shipped: {
    text: "Shipped",
    gradient: "linear-gradient(135deg, #3b82f6, #1d4ed8)",
  },
  out_for_delivery: {
    text: "Out for delivery",
    gradient: "linear-gradient(135deg, #0ea5e9, #0369a1)",
  },
  delivered: {
    text: "Delivered",
    gradient: "linear-gradient(135deg, #14b8a6, #0f766e)",
  },
  collected: {
    text: "Collected",
    gradient: "linear-gradient(135deg, #22c55e, #15803d)",
  },
  returned: {
    text: "At Lab",
    gradient: "linear-gradient(135deg, #65a30d, #3f6212)",
  },
  to_rgc: {
    text: "To RGC",
    gradient: "linear-gradient(135deg, #8b5cf6, #6d28d9)",
  },
  sequenced: {
    text: "Sequenced",
    gradient: "linear-gradient(135deg, #d946ef, #a21caf)",
  },
  ancestry_available: {
    text: "Ancestry Available",
    gradient: "linear-gradient(135deg, #ec4899, #be185d)",
  },
  error: {
    text: "Error",
    gradient: "linear-gradient(135deg, #ef4444, #b91c1c)",
  },
  dnag_error: {
    text: "DNAG Error",
    gradient: "linear-gradient(135deg, #f43f5e, #be123c)",
  },
  usps_error: {
    text: "Outbound USPS Error",
    gradient: "linear-gradient(135deg, #fb7185, #e11d48)",
  },
  return_usps_error: {
    text: "Return USPS Error",
    gradient: "linear-gradient(135deg, #e11d48, #9f1239)",
  },
  qc_failed: {
    text: "QC Failed",
    gradient: "linear-gradient(135deg, #dc2626, #7f1d1d)",
  },
};

// These are the props directly used when returning the component: <SpitKitStatus prop1={} prop2={} />
export type SpitKitStatusComponentProps = {
  status: RGCStatus;
};

export type SpitKitStatusProps = SpitKitStatusComponentProps;

function SpitKitStatus({ status }: SpitKitStatusProps) {
  const defaultStatusDisplay: RGCStatusDisplay = {
    text: "",
    gradient: "linear-gradient(135deg, #94a3b8, #64748b)",
  };
  let statusDisplay: RGCStatusDisplay;
  if (!statusDisplays[status]) {
    console.log('Unknown order status "%s"', status);
    statusDisplay = defaultStatusDisplay;
  } else {
    statusDisplay = statusDisplays[status];
  }
  const { gradient, text } = statusDisplay;

  return (
    <Badge
      className="badge-pill px-2 py-1 d-inline-flex align-items-center align-middle"
      style={{
        background: gradient,
        color: "#fff",
        fontWeight: 600,
        letterSpacing: "0.2px",
        boxShadow: "0 1px 2px rgba(0, 0, 0, 0.15)",
      }}
    >
      {text}
    </Badge>
  );
}

export default SpitKitStatus;
